import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import Multiselect from '../../MultiSelect'

const CreateModal = ({ editData, categries, handleRefresh, subcategories }) => {
  const uploadImage = useUploadImage()
  const { app_id } = useParams()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(editData?.category?.value || editData?.category?.[0]?.value || '')
  const [selectedCategoryObj, setSelectedCategoryObj] = useState(null)
  const [selectedEditOption, setSelectedEditOption] = useState(null)
  const [selectedType, setSelectedType] = useState(editData?.[0]?.type || '')
  const [selectedStatus, setSelectedStatus] = useState(editData?.[0]?.status || '')
  const AppService = useAppServices()
  const [user] = useUserInfo()

  const handlemodal = () => {
    setOpenAddProduct(true)
  }

  useEffect(() => {
    if (editData?.category) {
      const initialCategory = categries.find(
        cat => cat.value === (editData.category.value || editData.category[0]?.value)
      )
      setSelectedCategoryObj(initialCategory || null)
    }
    
    if (editData && editData.length > 0) {
      setSelectedType(editData[0].type || '')
      setSelectedStatus(editData[0].status || '')
    }
  }, [editData, categries])

  const filteredSubcategories = selectedCategory
    ? subcategories.filter((subcat) => subcat.category.value === selectedCategory)
    : []

  const editOptions = [
    { value: 'category', label: 'Edit Categories' },
    { value: 'type', label: 'Edit Type' },
    { value: 'status', label: 'Edit Status' }
  ]

  const typeOptions = [
    { value: 'levelupmarketplace', label: 'LevelUp Marketplace' },
    { value: 'agency', label: 'Agency' }
  ]

  const statusOptions = [
    { value: 'Publish', label: 'Publish' },
    { value: 'Draft', label: 'Draft' }
  ]

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      
      const selectedIds = editData.map(item => item._id)
      let payload = { selectedFaqs: selectedIds }
      let updateData = {}

      if (selectedEditOption === 'category') {
        const categoryObj = categries.find(cat => cat.value === selectedCategory)
        updateData.category = {
          id: categoryObj?.value,
          label: categoryObj?.label,
          ...categoryObj
        }
        
        // Handle subcategory if exists
        if (e.target?.subcategory?.value) {
          updateData.subcategory = JSON.parse(e.target?.subcategory?.value)
        }
      } 
      else if (selectedEditOption === 'type') {
        updateData.type = selectedType
      } 
      else if (selectedEditOption === 'status') {
        updateData.status = selectedStatus
      }

      // Add the update data to payload
      payload.updateData = updateData

      const { response } = await AppService.faq.updatebulk({ payload })
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      height: '80vh',
      overflowY: 'auto',
      bgcolor: 'background.paper',
      p: 4,
    }

    const handleCategoryChange = (e) => {
      const selectedValue = e.target.value;
      setSelectedCategory(selectedValue);
      const category = categries.find(cat => cat.value === selectedValue);
      setSelectedCategoryObj(category || null);
    }

    const handleEditOptionChange = (option) => {
      setSelectedEditOption(option)
    }

    const handleTypeChange = (e) => {
      setSelectedType(e.target.value)
    }

    const handleStatusChange = (e) => {
      setSelectedStatus(e.target.value)
    }

    const renderEditForm = () => {
      switch (selectedEditOption) {
        case 'category':
          return (
            <>
              <MDBox mb={2}>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Category
                </MDTypography>
                <MDInput
                  select
                  name="category"
                  fullWidth
                  required
                  SelectProps={{ native: true }}
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                >
                  <option value="">Select Category</option>
                  {categries.map((cat) => (
                    <option key={cat.value} value={cat.value}>
                      {cat.label}
                    </option>
                  ))}
                </MDInput>
              </MDBox>

              {filteredSubcategories.length > 0 && (
                <MDBox mb={2}>
                  <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                    Sub Category
                  </MDTypography>
                  <Multiselect
                    data={filteredSubcategories}
                    edit_data={editData?.subcategory || []}
                    isMulti={true}
                    name="subcategory"
                  />
                </MDBox>
              )}
            </>
          )
        
        case 'type':
          return (
            <MDBox mb={2}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Type
              </MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                SelectProps={{ native: true }}
                value={selectedType}
                onChange={handleTypeChange}
              >
                <option value="">Select Type</option>
                {typeOptions.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </MDInput>
            </MDBox>
          )
        
        case 'status':
          return (
            <MDBox mb={2}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Status
              </MDTypography>
              <MDInput
                select
                name="status"
                fullWidth
                required
                SelectProps={{ native: true }}
                value={selectedStatus}
                onChange={handleStatusChange}
              >
                <option value="">Select Status</option>
                {statusOptions.map((status) => (
                  <option key={status.value} value={status.value}>
                    {status.label}
                  </option>
                ))}
              </MDInput>
            </MDBox>
          )
        
        default:
          return (
            <MDBox mb={4}>
              <MDTypography variant="h6" mb={2}>
                What would you like to edit?
              </MDTypography>
              <MDBox display="flex" flexDirection="column" gap={2}>
                {editOptions.map((option) => (
                  <MDButton
                    key={option.value}
                    variant="gradient"
                    color="info"
                    onClick={() => handleEditOptionChange(option.value)}
                    fullWidth
                  >
                    {option.label}
                  </MDButton>
                ))}
              </MDBox>
            </MDBox>
          )
      }
    }

    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Bulk Edit FAQ
            </MDTypography>
            
            {renderEditForm()}

            <MDBox display="flex" justifyContent="flex-end">
              {selectedEditOption ? (
                <>
                  <MDButton
                    variant="gradient"
                    color="primary"
                    type="button"
                    sx={{ mt: 4, mb: 1 }}
                    onClick={() => {
                      setSelectedEditOption(null)
                      setSelectedCategory('')
                      setSelectedType('')
                      setSelectedStatus('')
                    }}
                  >
                    Back
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="info"
                    type="submit"
                    sx={{ mt: 4, mb: 1, ml: 1 }}
                    loading={processing}
                    disabled={processing}
                  >
                    Update
                  </MDButton>
                </>
              ) : (
                <MDButton
                  variant="gradient"
                  color="primary"
                  type="button"
                  sx={{ mt: 4, mb: 1 }}
                  onClick={onClose}
                >
                  Close
                </MDButton>
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  const closeAddProduct = () => {
    setOpenAddProduct(false)
    setSelectedEditOption(null)
    setSelectedCategory('')
    setSelectedType('')
    setSelectedStatus('')
  }

  return (
    <>
      <MDButton variant="contained" color="warning" size="small" onClick={handlemodal}>
        Bulk Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal